/**
 * "How to order" dropdown — preorder vs available-now vs any.
 *
 * Extracted from `app/(main)/products/ProductsClient.tsx` lines 1379–1397.
 */

"use client";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FilterSection } from "./FilterSection";

export type DeliveryTiming = "" | "buyOnline" | "enquireOnly";

interface DeliveryTimingSectionProps {
  value: DeliveryTiming;
  onChange: (v: DeliveryTiming) => void;
  isOpen: boolean;
  onToggleSection: (title: string) => void;
}

export function DeliveryTimingSection({
  value,
  onChange,
  isOpen,
  onToggleSection,
}: DeliveryTimingSectionProps) {
  return (
    <FilterSection
      title="How to order"
      count={value ? 1 : 0}
      isOpen={isOpen}
      onToggle={onToggleSection}
    >
      <Select
        value={value || "any"}
        onValueChange={(v) => {
          const next: DeliveryTiming =
            v === "any" ? "" : v === "buyOnline" || v === "enquireOnly" ? v : "";
          onChange(next);
        }}
      >
        <SelectTrigger className="w-full" aria-label="Filter by availability">
          <SelectValue placeholder="Choose an option" />
        </SelectTrigger>
        {/* position="popper" anchors the dropdown BELOW the trigger. The default
            "item-aligned" scrolls the nearest scrollable ancestor (the sidebar's
            .filter-scroll-container) to align the selected item under the
            trigger — which made the whole sidebar visibly jump/flicker on open. */}
        <SelectContent position="popper">
          <SelectItem value="any">Any</SelectItem>
          <SelectItem value="buyOnline">Preorder</SelectItem>
          <SelectItem value="enquireOnly">Available</SelectItem>
        </SelectContent>
      </Select>
    </FilterSection>
  );
}
